import Vue from "vue";
import moment from "moment";

Vue.filter("time", function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value));
    let hours = date.getHours();
    const min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      const time = hours > 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

Vue.filter("timeFormat", function (value) {
  if (value) {
    let dateString = combineDateAndTime(value);
    let format = window.localStorage.getItem("TimeFormat")
      ? window.localStorage.getItem("TimeFormat")
      : "HH:mm";
    if (format) {
      return moment(dateString).format(format);
    } else {
      return moment(dateString).format("HH:mm");
    }
  } else {
    return "-";
  }
});

Vue.filter("weekOfMonth", function (value) {
  if (value) {
    var date = moment(value);
    let weekInYearIndex = date.week();
    if (date.year() !== date.weekYear()) {
      weekInYearIndex =
        date
          .clone()
          .subtract(1, "week")
          .week() + 1;
    }
    const weekIndex =
      weekInYearIndex -
      moment(date)
        .startOf("month")
        .week() +
      1;
    return weekIndex;
  } else {
    return "-";
  }
});

Vue.filter("timefornotification", function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value));
    let hours = date.getHours();
    const min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      const time = hours < 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

Vue.filter("format12hours", function (value) {
  if (!value) return "-";
  else if (value)
    return value ? moment(value, ["HH:mm"]).format("h:mm A") : "-";
});

Vue.filter("format24hours", function (value) {
  if (!value) return "-";
  else if (value)
    return value ? moment(value, ["h:mm A"]).format("HH:mm") : "-";
});

////////////////////////
Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("uppercase", function (value) {
  if (!value) return value || "";
  return value.toUpperCase();
});

Vue.filter("activeParse", function (value) {
  if (!value) return value || "";
  return value === "Y" ? "Yes" : value === "N" ? "No" : "";
});
Vue.filter("dateparse-movies", function (value) {
  console.log("value", value);
  console.log("value1", moment(value, "DD/MM/YYYY"));
  value = moment(value, "DD/MM/YYYY");
  if (!value) return "-";
  else if (value === "Invalid date") return "-";
  else
    return value
      ? moment(value).format("DD-MM-YYYY") === "Invalid date"
        ? "-"
        : moment(value).format("DD MMM YYYY")
      : "-";
});

Vue.filter("dateparse", function (value) {
  if (!value) return "-";
  else if (value === "Invalid date") return "-";
  else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
    return value
      ? moment(value, "DD-MM-YYYY HH:mm").format("DD MMM YYYY")
      : "-";
  //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
  //this is changed acc to mams decision
  else
    return value
      ? moment(value).format("DD-MM-YYYY") === "Invalid date"
        ? "-"
        : moment(value).format("DD MMM YYYY")
      : "-";
});
Vue.filter("dayparse", function (value) {
  if (!value) return "-";
  else
    return value
      ? moment(value, "DD-MM-YYYY").calendar(null, {
        lastDay: "[Yesterday]",
        sameDay: "[Today]",
        nextDay: "[Tomorrow]",
        lastWeek: "[last] dddd",
        nextWeek: "dddd",
        sameElse: "dddd"
      })
      : "-";
});

Vue.filter("daynumber", function (value) {
  if (!value) return "-";
  else if (value && moment(value).format("dddd") === "Friday") return "1";
  else if (value && moment(value).format("dddd") === "Saturday") return "2";
  else if (value && moment(value).format("dddd") === "Sunday") return "3";
  else if (value && moment(value).format("dddd") === "Monday") return "4";
  else if (value && moment(value).format("dddd") === "Tuesday") return "5";
  else if (value && moment(value).format("dddd") === "Wednesday") return "6";
  else if (value && moment(value).format("dddd") === "Thursday") return "7";
});

// moment().format("dddd")
Vue.filter("daydate", function (value) {
  if (!value) return "-";
  else
    return value
      ? `${moment(value).format("ddd")} ${moment(value).format("DD")}`
      : "-";
});

Vue.filter("fulldateparse", function (value) {
  if (!value) return "-";
  else return value ? moment(value).format("DD-MM-YYYY HH:MM") : "-";
});

Vue.filter("timeparse", function (value) {
  if (!value) return "-";
  else return value ? moment(new Date(value)).format("LT") : "-";
});

Vue.filter("temptimeparse", function () { });

Vue.filter("getDay", function (value) {
  if (!value) return "-";
  else return value ? moment(new Date(value)).format("dddd") : "-";
});

Vue.filter("getMonth", function (value) {
  if (!value) return "-";
  else return value ? moment(new Date(value)).format("MMMM") : "-";
});

Vue.filter("getDayDigit", function (value) {
  if (!value) return "-";
  else return value ? moment(new Date(value)).format("Do") : "-";
});

Vue.filter("dayonly3", function (value) {
  if (!value) return "-";
  else return value ? moment(new Date(value)).format("ddd") : "-";
});

Vue.filter("timeparseAmPm", function (value) {
  // console.log('value :', value);
  if (!value) return "-";
  else
    return value
      ? moment(
        `${moment(new Date()).format("DD-MM-YYYY")} ${value}`,
        "DD-MM-YYYY HH:mm"
      ).format("h:mm A")
      : "-";
});

// Vue.filter('datetimeparseAmPm', function (value) {
//     console.log('value :', value);
//     if (!value) return '-'
//     else return value ? moment(`${moment(new Date()).format('DD-MM-YYYY')} ${value}`, 'DD-MM-YYYY HH:mm').format('h:mm A') : '-'
// });

Vue.filter("fulldatemonparse", function (value) {
  if (!value) return "-";
  else return value ? moment(value).format("DD-MMM-YYYY HH:mm") : "-";
});

Vue.filter("dateFormat", function (value) {
  if (!value) return "-";
  else return value ? moment(value).format("YYYY-MM-DD") : "-";
});

Vue.filter("time", function (value) {
  if (!value) return "-";
  else return value ? moment(value).format("hh:mm A") : "-";
});

Vue.filter("fulldaydateparse", function (value) {
  if (!value) return "-";
  else
    return value ? moment(new Date(value)).format("MMMM Do YYYY, h:mm a") : "-";
});

Vue.filter("RoundOff", function (value) {
  if (!value) return "0";
  else return value ? Math.round(value * 100) / 100 : "-";
});

Vue.filter("TimeStamptoDate", function (value) {
  if (!value) return "-";
  else return value ? moment(value * 1000).format("YYYY-MM-DD") : "-";
});

Vue.filter("convertTo12Hours", function (value) {
  if (!value) return "-";
  else {
    // Check correct time format and split into components
    value = value
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [value];

    if (value.length > 1) {
      // If time format correct
      value = value.slice(1); // Remove full string match value
      value[5] = +value[0] < 12 ? " AM" : " PM"; // Set AM/PM
      value[0] = +value[0] % 12 || 12; // Adjust hours
    }
    return value.join(""); // return adjusted time or original strin
  }
});

Vue.filter("TimeStamptoTime", function (value) {
  if (!value) return "-";
  else if (value.toString().length == 10)
    return value ? moment(value * 1000).format("hh:mm A") : "-";
  else return value ? moment(value).format("hh:mm A") : "-";
});

Vue.filter("filterNullUndefined", function (value) {
  if (!value) return "-";
  return value;
});

Vue.filter("dateParseYYYYMMDD", function (value) {
  if (!value) return "-";
  else return value ? moment(value).format("YYYY-MM-DD HH:mm") : "-";
});

export const combineDateAndTime = function (time) {
  let timeString = time;
  var dateString = moment().format("YYYY-MM-DD");
  var combined = new Date(dateString + " " + timeString);

  return combined;
};



// WEBPACK FOOTER //
// ./src/filters/filters.js